<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        예외
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Hash</a>
          </li>
      </ul>
    </div>
    <b-row>
      <b-col>
        <b-card>
          <b-row>
            <b-col>
              예외 파일 업로드
            </b-col>
          </b-row>
          <hr>
          <b-form-group>
            <b-form-file v-model="file" @change="bs_file" :disabled="lock" v-show="!lock"></b-form-file>
          </b-form-group>
          <div>
            <b-form-group>
              <label for="ph_md5">MD5 해시</label>
              <b-form-input md="5" type="text" id="ph_md5" v-model="model.hash" :disabled="lock"></b-form-input>
            </b-form-group>
            <b-form-group>
              <label for="ph_cause">설명</label>
              <b-form-textarea :disabled="lock" :rows="3" v-model="model.cause"></b-form-textarea>
            </b-form-group>
            <b-form-group>
              <label for="is_use_true">사용</label><br/>
              <c-switch :disabled="lock" v-model="model.is_alive"  color="success" label variant="pill"/><br>
            </b-form-group>
          </div>
          <hr/>
          <b-button class="btn-add" v-if="lock" size="sm" variant="warning" @click="lock = false"> 수정 </b-button>
          <b-button class="btn-add" v-else size="sm" variant="success" @click="save"> 저장 </b-button>
          <b-button size="sm" variant="danger" :disabled="!lock" @click="confirm=true"> 삭제  </b-button>
          <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> 목록으로 </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="삭제"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      선택한 정보를 삭제 하시겠습니까?
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
